import SpriteSymbol from "../../../../../common/temp/node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../tools/svg-sprite.js";
var symbol = new SpriteSymbol({
  "id": "icon-handicap-sell-dark",
  "use": "icon-handicap-sell-dark-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 20 20\" id=\"icon-handicap-sell-dark\"><path fill=\"#EF454A\" d=\"M2 3h6v14H2z\" /><g fill=\"#fff\" opacity=\".8\"><path d=\"M10 3h8v2h-8zM10 7h8v2h-8zM10 11h8v2h-8v-2ZM10 15h8v2h-8v-2Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol